import PrExpandCollapse from './pr-expand-collapse';
export default PrExpandCollapse;
